import * as React from 'react';

const DigitalOrdering = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={57.697}
    height={47.431}
    viewBox='0 0 57.697 47.431'
    {...props}
  >
    <g id='shopping-cart' transform='translate(0 -46.002)'>
      <circle
        id='Ellipse_323'
        data-name='Ellipse 323'
        cx={4.993}
        cy={4.993}
        r={4.993}
        transform='translate(18.307 83.448)'
        fill='#fff'
      />
      <circle
        id='Ellipse_324'
        data-name='Ellipse 324'
        cx={4.993}
        cy={4.993}
        r={4.993}
        transform='translate(39.11 83.448)'
        fill='#fff'
      />
      <path
        id='Path_6207'
        data-name='Path 6207'
        d='M1.69,49.383H8.97l8.107,29.188a1.691,1.691,0,0,0,1.629,1.238H49.133a1.692,1.692,0,0,0,1.626-1.227l6.874-23.665a1.689,1.689,0,0,0-1.626-2.154H13.417L11.884,47.24A1.691,1.691,0,0,0,10.255,46H1.69a1.69,1.69,0,0,0,0,3.381ZM42.371,73.047h-16.9a1.69,1.69,0,1,1,0-3.381h16.9a1.69,1.69,0,1,1,0,3.381ZM22.087,62.905H45.752a1.69,1.69,0,0,1,0,3.381H22.087a1.69,1.69,0,0,1,0-3.381Z'
        transform='translate(0 0)'
        fill='#fff'
      />
    </g>
  </svg>
);
export default DigitalOrdering;
